
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Viele Betroffene wissen gar nicht, welche Art von Kopfschmerz sie plagt. Folglich erhalten sie auch nicht die optimale Behandlung. Höchstens fünf von zehn an Migräne Leidenden ist zum Beispiel klar, dass sie Migräne haben. Wird die Diagnose «Migräne» gestellt, werden meist auch wirksamere Medikamente eingesetzt.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;